<template>
  <v-container fluid>
    <BaseDetailItem
        ref="BomSheetItem"
        :value="editedItem"
        @cancel="$emit('update:dialog', false); editedItem=newItem()"
        @save="$emit('save', $event); editedItem=newItem()"
        text-save="Save"
    >
      <template v-slot:body="{editedItem, lockPage, instance, slotHeight, editedItemCommon}">
        <v-sheet>
          <v-container fluid>
            <v-row no-gutters dense>
              <BaseCardListBlock :title="$t('common')">
                <template v-slot:left>
                  <BatchRunStatus v-model="editedItem.status" large></BatchRunStatus>
                </template>
                <template>
                  <v-row dense no-gutters class="flex nowrap px-3">
                    <v-col class="d-flex justify-end"><span class="text-h6">{{ editedItem.title }}</span></v-col>
                    <v-col class="d-flex justify-end ml-3" cols="1"></v-col>
                  </v-row>
                  <v-divider></v-divider>
                  <v-row v-if="!!editedItem.delivery_date" dense no-gutters class="flex nowrap px-3">
                    <v-col class="d-flex justify-end"><span class="text-h6">{{ $t('columns.delivery') }}</span></v-col>
                    <v-col class="d-flex justify-end ml-3"><span class="text-h6">{{ editedItem.delivery_date }}</span>
                    </v-col>
                  </v-row>
                  <v-divider></v-divider>
                  <v-row dense no-gutters class="flex nowrap px-3">
                    <v-col class="d-flex justify-end"><span class="text-h6">{{ $t('columns.qty') }}</span></v-col>
                    <v-col class="d-flex justify-end ml-3"><span class="text-h6">{{ editedItem.quantity }}</span>
                    </v-col>
                  </v-row>
                  <v-divider></v-divider>
                  <v-row v-if="!!editedItem.sn_from" dense no-gutters class="flex nowrap px-3">
                    <v-col class="d-flex justify-end"><span class="text-h6">{{ $t('columns.sn') }}</span></v-col>
                    <v-col class="d-flex justify-end ml-3"><span
                        class="text-h6">{{ editedItem.sn_from }}-{{ editedItem.sn_to }}</span></v-col>
                  </v-row>
                </template>
              </BaseCardListBlock>
              <v-spacer></v-spacer>
              <BaseCardListBlock title="SMD" v-if="editedItem.lot_size_smd > 0" class="mr-6">
                <template v-slot:left>
                  <BatchRunStatus v-model="editedItem.status" large></BatchRunStatus>
                </template>
                <template>
                  <v-row dense no-gutters class="flex nowrap px-3">
                    <v-col class="d-flex justify-center mx-5"><span class="text-h6">{{ $t('columns.qty') }}</span>
                    </v-col>
                    <v-col class="d-flex justify-end"><span class="text-h6">{{ editedItem.lot_size_smd }}</span></v-col>
                  </v-row>
                </template>
              </BaseCardListBlock>
              <BaseCardListBlock title="THT" v-if="editedItem.lot_size_tht > 0">
                <template v-slot:left>
                  <BatchRunStatus v-model="editedItem.status" large></BatchRunStatus>
                </template>
                <template>
                  <v-row dense no-gutters class="flex nowrap px-3">
                    <v-col class="d-flex justify-end mx-5"><span class="text-h6">{{ $t('columns.qty') }}</span></v-col>
                    <v-col class="d-flex justify-end"><span class="text-h6">{{ editedItem.lot_size_tht }}</span></v-col>
                  </v-row>
                </template>
              </BaseCardListBlock>
            </v-row>
          </v-container>
          <BaseDetailTableFiltered
              ref="refBaseDetailFilteredTableImport"
              :item-list.sync="editedItem.batchrun_tasks"
              :height="componentHeight - 300"
              :height-toolbar="48"
              dialog-width="90%"
              :columns="columnsBatchRunTask"
              edit-component-path="/PBatchRun/BatchRunTask/PBatchRunTaskItem"
              :left-cols="12"
              :show-select="false"
              :single-select="false"
              :edited-item="editedItem"
              :fetch-action="PBatchRunTable_fetchAction"
              row-statuses="row_status"
              row-filter-names="row_filters"
              :show-expand="false"
              :single-expand="false"
              item-key="uid"
              sort-by="order"
          >
            <template v-slot:top>
              {{ '' }}
            </template>
            <template v-slot:top.bar.action.middle="params">
              <BaseBtnActionGroup
                  :bar-action-group="editedItemCommon.bar_actions"
                  :fetch-action="instance.fetchAction"
                  :edited-item="editedItem"
                  :selected-items="params.selectedItems"
                  :loading="instance.commandLoading"
              >
              </BaseBtnActionGroup>
            </template>
            <template v-slot:top.bar.action.right="params">
              {{ '' }}
            </template>
            <template v-slot:top.bar.overlay="params">
            </template>
            <template v-slot:item.name="{ item }">
              <span class="text-h6">{{ item.name }}</span>
            </template>
            <template v-slot:item.target_on="{ item }">
              <BaseFieldDate v-model="item.target_on"></BaseFieldDate>
            </template>
            <template v-slot:item.status="{ item }">
              <BatchRunTaskSelect v-model="item.status" @input="$emit('update', editedItem)"></BatchRunTaskSelect>
            </template>
            <template v-slot:item.typ="{ item }">
              <BatchRunTaskName :value="item.typ"></BatchRunTaskName>
            </template>
            <template v-slot:item.ma="{ item }">
              <BaseSelectFromTable
                  v-model="item.ma"
                  store-name="UserTable"
                  dto-model="UserListQueryDTO"
                  item-text="human_user__user"
                  multiple
                  chips
                  hide-details
              ></BaseSelectFromTable>
            </template>
          </BaseDetailTableFiltered>
        </v-sheet>
      </template>
    </BaseDetailItem>
  </v-container>
</template>

<script>
import {v4 as uuidv4} from "uuid";
import commonFunction from "@/commonFunction/commonFunction"
import BaseTable from "@/components/Base/BaseTable";
import BaseItemProperty from "@/components/Base/BaseItemProperty";
import BaseDeleteIcon from "@/components/Base/BaseDeleteIcon";
import BaseFieldText from "@/components/Base/BaseFieldText";
import BaseDialogSelectFromTable from "@/components/Base/BaseDialogSelectFromTable";
import BaseDetailItem from "@/components/Base/BaseDetailItem";
import BaseFieldString from "@/components/Base/BaseFieldString";
import BaseFieldNumber from "@/components/Base/BaseFieldNumber";
import BaseFieldCheck from "@/components/Base/BaseFieldCheck";
import BaseFieldSelect from "@/components/Base/BaseFieldSelect";
import BaseNotionLink from "@/components/Base/BaseNotionLink";
import PBatchRunEditDialog from "@/components/PBatchRun/BatchRun/PBatchRunEditDialog";
import BaseFieldWeek from "@/components/Base/BaseFieldWeek";
import BaseDetailTableFiltered from "@/components/Base/BaseDetailTableFiltered";
import BaseBtnActionGroup from "@/components/Base/BaseBtnActionGroup";
import BatchRunTaskSelect from "@/components/PBatchRun/BatchRunTask/BatchRunTaskStatusSelect";
import BatchRunTaskName from "@/components/PBatchRun/BatchRunTask/BatchRunTaskName";
import BaseFieldDate from "@/components/Base/BaseFieldDate";
import BaseSelectFromTable from "@/components/Base/BaseSelectFromTable";
import BatchRunStatus from "@/components/PBatchRun/BatchRun/BatchRunStatus";
import BaseCardListBlock from "@/components/Base/BaseCardListBlock";

export default {
  name: 'BatchRunEditDialog',
  props: {
    value: {default: null},
    dialog: {default: true},
  },

  components: {
    BaseFieldSelect,
    BaseTable,
    BaseItemProperty,
    BaseDeleteIcon,
    BaseFieldText,
    BaseDialogSelectFromTable,
    BaseDetailItem,
    BaseFieldString,
    BaseFieldNumber,
    BaseFieldCheck,
    BaseNotionLink,
    PBatchRunEditDialog,
    BaseFieldWeek,
    BaseDetailTableFiltered,
    BaseBtnActionGroup,
    BatchRunTaskSelect,
    BatchRunTaskName,
    BaseFieldDate,
    BaseSelectFromTable,
    BatchRunStatus,
    BaseCardListBlock,
  },

  computed: {},

  watch: {
    value: {
      handler(newValue, oldValue) {
        console.log('watch', newValue, oldValue)
        if (newValue === null)
          this.editedItem = this.newItem()
        else {
          this.editedItem = JSON.parse(JSON.stringify(this.value))
        }
      },
      deep: true
    },
  },

  methods: {
    ...commonFunction.mapStoreActions(['PBatchRunTable/fetchAction',]),
    newItem() {
      return {
        uid: uuidv4(),
        id: null,
        qty: 1,
        original_description: null,
        description: null,
        original_mpn: null,
        mpn: null,
        alias: null,
        customer_article: null,
        article: null,
        status: null,
        task_status: {
          error: {},
          status: 'empty',
        },
        component: null,
      }
    },
  },

  mounted() {
    if (this.value === null)
      this.editedItem = this.newItem()
    else {
      this.editedItem = JSON.parse(JSON.stringify(this.value))
    }
  },

  data() {
    return {
      componentHeight: window.innerHeight,
      editedItem: this.newItem(),
      columnsBatchRunTask: [
        // {text: '', value: 'edit', sortable: false, align: 'center', divider: true, width: 10},
        // {
        //   text: 'S',
        //   value: 'row_status',
        //   sortable: false,
        //   align: 'center',
        //   divider: false,
        //   width: 20,
        //   type: 'status'
        // },
        // {text: 'order', value: 'order', sortable: false, align: 'left', divider: true, width: 30},
        {text: this.$t('columns.name'), value: 'name', sortable: false, align: 'left', divider: true},
        {text: this.$t('columns.typ'), value: 'typ', sortable: false, align: 'center', divider: true, width: 100},
        {
          text: this.$t('columns.target_on'),
          value: 'target_on',
          sortable: false,
          align: 'center',
          divider: true,
          width: 100
        },
        {text: this.$t('columns.status'), value: 'status', sortable: false, align: 'center', divider: true, width: 150},
        {text: this.$t('columns.ma'), value: 'ma', sortable: false, align: 'center', divider: true, width: 300},
        {
          text: this.$t('columns.finished_on'),
          value: 'finished_on',
          sortable: false,
          align: 'center',
          divider: true,
          type: 'datetime',
          width: 120
        },
      ],
    }
  },
}

</script>

<style scoped lang="scss">
.table-article-info {
  border: thin solid;
  border-collapse: separate;
}
</style>

<i18n src="@/components/PBatchRun/locales.json">
</i18n>